import configureStore from './configureStore';

const { Store, Persistor, sagaMiddleware } = configureStore();
export { Store, Persistor, sagaMiddleware };
